import EmployeeDetail from '../../employees/detail';

const General = () => {
  return <EmployeeDetail />;
};

export default General;
